export const TYPE_HALOTEL_REVENUE = "TYPE_HALOTEL_REVENUE";
export const POST_DATA_HALOTEL = "POST_DATA_HALOTEL";
